
import Vue from 'b2b-common/vue-config'
import axios from 'b2b-common/vue-config/axios'
import router from 'b2b-common/vue-config/router'
import 'b2b-common/vue-config/bootstrap.scss'
import '@/assets/scss/bootstrap-custom.scss'
import './config/vee-validate'
import './config/gettext'
import routes from './routes'
import App from './app.vue'

axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '/server/' : 'https://b2bstaging.marioviajes.com/server/'

router.addRoutes(routes)

export default new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
